import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiCheck, FiX, FiAlertTriangle, FiInfo } = FiIcons;

const CompatibilityMatrix = ({ matrix }) => {
  const getCompatibilityIcon = (level) => {
    switch (level.toLowerCase()) {
      case 'excellent':
        return { icon: FiCheck, color: 'text-green-600', bg: 'bg-green-100' };
      case 'good':
        return { icon: FiCheck, color: 'text-blue-600', bg: 'bg-blue-100' };
      case 'fair':
        return { icon: FiAlertTriangle, color: 'text-yellow-600', bg: 'bg-yellow-100' };
      case 'poor':
        return { icon: FiX, color: 'text-red-600', bg: 'bg-red-100' };
      default:
        return { icon: FiInfo, color: 'text-gray-600', bg: 'bg-gray-100' };
    }
  };

  const getCompatibilityText = (level) => {
    switch (level.toLowerCase()) {
      case 'excellent':
        return 'Ausgezeichnet';
      case 'good':
        return 'Gut';
      case 'fair':
        return 'Bedingt';
      case 'poor':
        return 'Ungeeignet';
      default:
        return 'Unbekannt';
    }
  };

  return (
    <motion.div
      className="bg-white rounded-lg shadow-sm border border-gray-200 p-6"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.3 }}
    >
      <h2 className="text-xl font-bold text-gray-900 mb-6">Chemische Beständigkeit</h2>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {Object.entries(matrix).map(([medium, compatibility], index) => {
          const { icon, color, bg } = getCompatibilityIcon(compatibility);
          
          return (
            <motion.div
              key={medium}
              className="flex items-center justify-between p-4 border border-gray-200 rounded-lg"
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.3, delay: index * 0.1 }}
            >
              <div className="flex items-center space-x-3">
                <div className={`w-8 h-8 rounded-full ${bg} flex items-center justify-center`}>
                  <SafeIcon icon={icon} className={`w-4 h-4 ${color}`} />
                </div>
                <div>
                  <p className="font-medium text-gray-900 capitalize">
                    {medium.replace(/_/g, ' ')}
                  </p>
                </div>
              </div>
              <span className={`px-3 py-1 rounded-full text-sm font-medium ${bg} ${color}`}>
                {getCompatibilityText(compatibility)}
              </span>
            </motion.div>
          );
        })}
      </div>

      <div className="mt-6 p-4 bg-blue-50 rounded-lg">
        <div className="flex items-start space-x-3">
          <SafeIcon icon={FiInfo} className="w-5 h-5 text-blue-600 mt-0.5" />
          <div>
            <h3 className="font-semibold text-blue-900 mb-1">Hinweise zur Medienbeständigkeit</h3>
            <p className="text-sm text-blue-800">
              Die Angaben basieren auf Standardbedingungen (20°C, 1 bar). Bei erhöhten Temperaturen, 
              Drücken oder besonderen Medienzusammensetzungen können abweichende Beständigkeiten auftreten. 
              Für kritische Anwendungen empfehlen wir eine individuelle Beratung.
            </p>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default CompatibilityMatrix;